import { fork, all } from 'redux-saga/effects'
import { processSaga, watchSaga } from '../workflow'
import at from '../../actionTypes' // eslint-disable-line import/no-named-as-default, temporary until we only export the one thing
import postCommentDeleteByPostOwner from './sagas'
import getPostCommentsByPostId from '../../../dataservices/getPostCommentsByPostId'
import addPostComment from '../../../dataservices/addPostComment'
import deletePostComment from '../../../dataservices/deletePostComment'
import actionWorkflows from '../../actionWorkflows'

const postCommentsFetchWorkflow = processSaga.bind(null, actionWorkflows.postCommentsFetch, getPostCommentsByPostId)
const postCommentAddWorkflow = processSaga.bind(null, actionWorkflows.postCommentAdd, addPostComment)
const postCommentDeleteWorkflow = processSaga.bind(null, actionWorkflows.postCommentDelete, deletePostComment)
const postCommentDeleteByPostOwnerWorkflow = processSaga.bind(null, actionWorkflows.postCommentDeleteByPostOwner, postCommentDeleteByPostOwner)

export default function* root() {
	yield all([
		fork(watchSaga.bind(null, at.postCommentsFetch, postCommentsFetchWorkflow, { latest: true })),
		fork(watchSaga.bind(null, at.postCommentAdd, postCommentAddWorkflow, { latest: true })),
		fork(watchSaga.bind(null, at.postCommentDelete, postCommentDeleteWorkflow, { latest: true })),
		fork(watchSaga.bind(null, at.postCommentDeleteByPostOwner, postCommentDeleteByPostOwnerWorkflow, { latest: true }))
	])
}



// WEBPACK FOOTER //
// ./src/redux/saga/comments/index.js